import React from 'react';

import { PolicyTerms } from '../../../components';
import { privacyPolicy } from '../../../constants';



const PrivacyPolicy = () => { 

  return (
    <PolicyTerms 
      title="Privacy Policy"  // Page title
      page="Privacy Policy"   // Page identifier
      policies={privacyPolicy}    // Passing privacy policy content as props
    />
);
}

export default PrivacyPolicy;